import { createFileRoute } from "@tanstack/react-router";

import { PlaygroundPage } from "#/pages/playground";

export const Route = createFileRoute("/_console/playground")({
  component: PlaygroundPage,
});
